import { useEffect, useRef } from "react";
import { useAtom } from "jotai";
import { currentMenuNumAtom } from "../../components/atoms/currentMenuState";

/**
 * InactivityTimeout コンポーネントは、ユーザーのタッチ操作を監視し、
 * 一定時間（ここでは10分）操作がない場合に、10分単位で各ボタンに移動する(ループ)ためのコンポーネントです。※ ただし、icommons施設案内はループから除く
 *
 * 主な機能:
 * - タッチ操作があった場合、タイマーをリセット。
 * - 10分間操作がなければ、currentMenuNum を 0→ 1→ 2→ 3→ 4→ 5→ 0に移動(ループ)。
 * - サイネージやタッチインターフェースでの無操作状態を管理するのに適しています。
 *
 * currentMenuNum を変更することで、メニューや画面遷移を制御できます。
 */

const InactivityTimeout = () => {
  const [, setCurrentMenuNum] = useAtom(currentMenuNumAtom);
  const loopCountRef = useRef(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const LOOP_INTERVAL_MS = 10 * 60 * 1000; // 10分
  const MAX_LOOP_COUNT = 24;

  useEffect(() => {
    const startInterval = () => {
      intervalRef.current = setInterval(() => {
        setCurrentMenuNum((prev) => {
          const next = (prev + 1) % 6;
          return next;
        });

        // useRefを使ってループ回数を更新
        loopCountRef.current += 1;
        if (loopCountRef.current >= MAX_LOOP_COUNT) {
          window.location.reload();
        }
      }, LOOP_INTERVAL_MS); // 10分
    };

    const handleTouchStart = () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      startInterval();
    };

    startInterval();
    window.addEventListener("touchstart", handleTouchStart);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      window.removeEventListener("touchstart", handleTouchStart);
    };
  }, [setCurrentMenuNum]);

  return null;
};

export default InactivityTimeout;
